const countryUSCanadaOnly: { [key: string]: string } = {
  CA: 'Canada',
  US: 'United States',
};

export default countryUSCanadaOnly;
